<template>
  <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Todas las variedades</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            class="select-primary"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <div>
          <base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Buscar..."></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light" @sort-change="sortChange">
        <el-table-column label="Nombre" sortable min-width="120px" prop="name"> </el-table-column>

        <el-table-column label="Descripción" sortable min-width="250px" prop="description"> </el-table-column>

        <el-table-column label="Cultivo" sortable min-width="100px" prop="crop.name"> </el-table-column>

        <el-table-column label="Es para venta" sortable min-width="100px" prop="forSale">
          <template #default="{ row }">
            <div>
              {{ row.forSale ? 'Si' : 'No' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="right" label="" min-width="140px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('update', 'varieties')"
              :to="{ name: 'VarietyEdit', params: { id: row.id } }"
              class="btn base-button btn-outline-primary btn-sm"
            >
              <i class="fas fa-pen"></i>
            </router-link>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ total }} variedades</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        class="pagination-no-border"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';

export default {
  name: 'VarietiesTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationMixin],
  data() {
    return {
      searchKeys: ['name', 'description', 'crop.name'],
      tableData: [],
    };
  },

  computed: {
    isForSale(crop) {
      if (crop.forSale) {
        return 'Sí';
      } else {
        return 'No';
      }
    },
  },

  mounted() {
    this.$services
      .resource('varieties')
      .get({ include: 'crop' })
      .then((res) => res.data.data)
      .then((data) => (this.tableData = data.varieties));
  },
};
</script>
